import React, { useState } from 'react'
import Me from "ischart-deploy/components/Me";
import { ISCHART_INFORMATICS_GS, ISCHART_STUDIO_GS } from "informatics/config";

const CardIsChartWrapper = (props: any) => {
  console.log('CardIsChartWrapper props: ', props);

  const [datasetId, setDatasetId] = useState("")
  const [selectedTab, setSelectedTab] = useState("")
  const [chartInfo, setChartInfo] = useState({})
  const [allDivisionRead, setAllDivisionRead] = useState(false)
  const [selectedDivision, setSelectedDivision] = useState(0)

  return (<>
    <Me
      view="chart"
      useCloud={true}
      Admin={null}
      isAdmin={props.isAdmin}
      IHV3={true}
      config={{ ...props.config, ISCHART_INFORMATICS_GS, ISCHART_STUDIO_GS }}
      bindingDropdown={true}
      hideSelectorPanel={true}
      controller={props.controller}
      loggedin={props.loggedin}
      userProfile={props.userProfile}
      selectedDivisionIHV3={allDivisionRead ? { id: selectedDivision } : props.selectedDivisionIHV3}
      datasetId={datasetId}
      selectedTab={selectedTab}
      permitToken={props.permitToken}
      setChartInfo={(selector: any) => {
        console.log("selector", selector)

        if (Object.keys(chartInfo)?.length !== Object.keys(selector?.chartInfo)?.length) {
          let projects = Object.keys(selector?.chartInfo)
          console.log('projects: ', projects);
          if (projects?.length > 0) {
            let choose = projects?.find((i) => i.includes("diag"))
            console.log('1 choose: ', choose);
            if (!choose) {
              choose = projects?.[0]
            }
            console.log('2 choose: ', choose);
            let tabs = Object.keys(selector?.chartInfo?.[choose]?.displayItems)
            setDatasetId(choose)
            if (tabs?.length > 0) {
              setSelectedTab(tabs[0])
            }

          }
        }
        if (selector?.chartInfo) {
          setChartInfo(selector?.chartInfo)
        }
        setAllDivisionRead(!!selector?.allDivisionRead)
      }}
    />
  </>


  )
}

export default CardIsChartWrapper